import { createSelector } from 'reselect'
import { immutableSelector } from 'utils/selectors'
import { ORG_PROFILE_DOMAIN, PROFILE_DOMAIN } from 'constants/ResourcesConstants'
import { orgHandle } from 'app/modules/org/selectors'

import { constants } from './constants'
import { Overview, Social, Details, Messaging, Theme } from './models'

export const profile = state => state.getIn(['profile', 'data'])
export const profileFetchStatus = state => state.getIn(['profile', 'status', 'fetch'])
export const profileUpdateStatus = state => state.getIn(['profile', 'status', 'update'])
export const profileUpdateStatusPending = state =>
  state.getIn(['profile', 'status', 'update']) === constants.UPDATE_PROFILE_STARTED
export const profileUpdateStatusSuccess = state =>
  state.getIn(['profile', 'status', 'update']) === constants.UPDATE_PROFILE_SUCCESS

export const isLoaded = createSelector(
  profileFetchStatus,
  profileFetchstatus => profileFetchstatus === constants.RECEIVE_PROFILE
)

export const overview = immutableSelector(
  isLoaded,
  profile,
  (isLoaded, profile) => (isLoaded ? Overview(profile) : undefined)
)
export const social = immutableSelector(
  isLoaded,
  profile,
  (isLoaded, profile) => (isLoaded ? Social(profile) : undefined)
)
export const details = immutableSelector(
  isLoaded,
  profile,
  (isLoaded, profile) => (isLoaded ? Details(profile) : undefined)
)
export const messaging = immutableSelector(
  isLoaded,
  profile,
  (isLoaded, profile) => (isLoaded ? Messaging(profile) : undefined)
)
export const theme = immutableSelector(
  isLoaded,
  profile,
  (isLoaded, profile) => (isLoaded ? Theme(profile) : undefined)
)

export const handle = state => state.getIn(['profile', 'data', 'handle'])
export const globalHandle = state => state.getIn(['profile', 'data', 'globalHandle'])

export const isHandleSet = createSelector(
  handle,
  globalHandle,
  (handle, globalHandle) => !!handle || !!globalHandle
)
export const companyUrl = createSelector(orgHandle, handle => `${handle}${ORG_PROFILE_DOMAIN}`)

export const companyProfileUrl = createSelector(
  companyUrl,
  handle,
  (companyUrl, handle) => `https://${companyUrl}/${handle}`
)

export const profileUrlHandle = createSelector(handle, globalHandle, (handle, globalHandle) => {
  return globalHandle || handle
})
export const profileUrl = createSelector(globalHandle, globalHandle => {
  if (!globalHandle) {
    return ''
  }
  return `https://${PROFILE_DOMAIN}/${globalHandle}`
})

export const visibility = state => state.getIn(['profile', 'visibility'])



// WEBPACK FOOTER //
// ./src/scripts/app/modules/profile/selectors.js